import universalImg from "../assets/images/universal.svg";
import privacyImg from "../assets/images/privacy.svg";
import blockchainImg from "../assets/images/blockchain.svg";
import openImg from "../assets/images/open.svg";

export const benefitsEn = [
    {
        icon: universalImg,
        title: "Universal Gaming",
        detail: "Play on Windows, Linux, macOS. Embrace the freedom of blockchain gaming.",
        gradient: 'red-gradient-smooth'
    },
    {
        icon: privacyImg,
        title: "Privacy & Security",
        detail: "No personal data needed. Shop anonymously with confidence.",
        gradient: 'purple-gradient-smooth'
    },
    {
        icon: blockchainImg,
        title:"Blockchain Power",
        detail: "Play blockchain and traditional games on one platform, from one launcher.",
        gradient: 'blue-gradient-smooth'
    },
    {
        icon: openImg,
        title: "Open Platform",
        detail: "Anyone can be a player, anyone can be a creator, and publish games to tymt .",
        gradient: 'yellow-gradient-smooth'
    }
]

export const benefitsJp = [
    {
        icon: universalImg,
        title: "ユニバーサルゲーミング",
        detail: "Windows、Linux、macOSでプレイ。ブロックチェーンゲームの自由をその手に！",
        gradient: 'red-gradient-smooth'
    },
    {
        icon: privacyImg,
        title: "プライバシーとセキュリティ",
        detail: "個人情報は必要ありません。匿名で安心してお買い物ができます。",
        gradient: 'purple-gradient-smooth'
    },
    {
        icon: blockchainImg,
        title:"ブロックチェーンパワー",
        detail: "ブロックチェーンと従来のゲームを1つのプラットフォームで、1つのランチャーからプレイ可能",
        gradient: 'blue-gradient-smooth'
    },
    {
        icon: openImg,
        title: "オープンプラットフォーム",
        detail: "誰もがプレイヤーになれ、また誰もがゲームをtymt™に公開してクリエイターにもなれます。",
        gradient: 'yellow-gradient-smooth'
    }
]
